<div class="ButtonContainer Flexbox Justify--center">
  <button (click)="activeTab.set(0)" class="TabButton" [class.Active]="activeTab() === 0">Model Editor</button>
  <button (click)="activeTab.set(1)" class="TabButton" [class.Active]="activeTab() === 1">Design Checker</button>
</div>
@if(activeTab() === 0) {
  <app-admin-controls-single-texture-viewer></app-admin-controls-single-texture-viewer>
} @else {
  <app-admin-controls-texture-check></app-admin-controls-texture-check>
}
